// Uses its own localStorage key (distinct from the platform-wide `i18nextLng`
// key that useLanguageInitialization watches) so picking a contract language
// never triggers a platform UI language switch.
export const CONTRACT_LANG_STORAGE_KEY = 'contractLang';

export const resolveContractLang = (): string =>
  window.localStorage.getItem(CONTRACT_LANG_STORAGE_KEY)
  || 'en-us';
